<template>
    <CSidebar        
        fixed
        :minimize="minimize"
        :show="show"
        @update:show="(value) => $store.commit('set', ['sidebarShow', value])">
        <CSidebarBrand class="d-md-down-none" to="/">
            {{$t('SystemTitle')}}
        </CSidebarBrand>        
        <CRenderFunction flat :content-to-render="menuItem" :key="index" />          
    </CSidebar>
</template>
<script>
import navData from "./_nav";
import { mapGetters } from 'vuex'

export default {
    name: "TheSidebar",
    data() {
        return {
            index: 0      //為了重新渲染用的key       
        }     
    },
    computed: {
        ...mapGetters(['lang']),
        show() {
            return this.$store.state.sidebarShow;
        },
        minimize() {
            return this.$store.state.sidebarMinimize;
        },
        isEmployee() {
            return this.$store.state.isEmployee;
            //return false;
        },
        menuItem() {// 動態更換語系選單方式
            if(navData && navData.length){                       
                let allowList = [];
                let userInfo = this.$store.getters['userInfo'];    
                let roleId= '';            
                if(userInfo && userInfo.account){
                    //判斷目前帳戶與可允許的路徑
                    // let userType = userInfo.userType;
                    // if(userType === 'Employee' || userType === 'Member'){                         
                    //     allowList = routesAllowMap[userType];                        
                    // } 
                    allowList = userInfo.allowRouterNameList;
                    // allowList = [ ...userInfo.allowRouterNameList, 'RFQSearchList', 'RFQEdit' ];  
                    roleId = userInfo.roleId;
                }
                const nav = navData[0];                
                //const t = this.$t; //會有例外錯誤
                const t = key => this.$t(key);//改用此方式避開
                let list = nav._children;      
                const removeList =[];    
                let index = 0;      
                list.forEach(it => {      
                    if('Quality' === it.keyStr) { //品質需求，有次選單
                        let secondItems=it.items;
                        const removeSecondList =[]; 
                        let secondIndex =0;
                        secondItems.forEach(it02 => {
                            if(!allowList.includes(it02.keyStr)){//無相關項目
                                removeSecondList.push(secondIndex);
                            }
                            it02.name = t('MenuItem.' + it02.keyStr);
                            secondIndex++;
                        });
                        //移除不需要的項目
                        if(removeSecondList.length >0){
                            removeSecondList.reverse().forEach(ii => {   
                                secondItems.splice(ii,1);
                            });
                        }                        
                        if(secondItems && secondItems.length === 0){
                            removeList.push(index);
                        }
                    }else if ('PurchaseSearchList' === it.keyStr){ //招標管理，須根據不同身分調整 to 路徑
                        if('-M' === roleId){
                            it.to =  '/Manufacturer';
                        }else if('-QM' === roleId){
                            it.to = '/plan_masterfile';
                            removeList.push(index);
                            index+=1;
                            return;
                        }else if(roleId && (roleId.indexOf('物管') > -1 || roleId.indexOf('品質') > -1)){
                            it.to = '/plan_masterfile';
                            removeList.push(index);
                            index+=1;
                            return;
                        }
                        else if(roleId && (roleId.indexOf('詢價') > -1)){
                            // it.to = '/plan_masterfile';
                            removeList.push(index);
                            // index+=1;
                            // return;
                        }
                    } 
                    // else if ('RequestSearchList' === it.keyStr){ //詢價需求單管理
                    //     if('-M' === roleId || '-QM' === roleId){
                    //         it.to = '/suppliersearchlist';
                    //         it.keyStr = 'SupplierSearchList';
                    //     } else {
                    //         it.to = '/requestsearchlist';
                    //         // removeList.push(index);
                    //         // index+=1;
                    //         // return;
                    //     }
                    // }
                    else { 
                        if(!allowList.includes(it.keyStr)){//無相關項目
                            removeList.push(index);
                            index+=1;
                            return;
                        }
                    }
                    it.name = t('MenuItem.' + it.keyStr);
                    index+=1;
                });
                if(removeList.length >0){
                    removeList.reverse().forEach(ii => {   
                        list.splice(ii,1);
                    });
                }
            }
            return navData;
        }
    },
    methods: {
         
    },
    watch: {
        lang: function() {
            this.index++
        }
    }
};
</script>
<style lang="scss" scoped>
.c-sidebar .c-sidebar-nav-link.c-active, .c-sidebar .c-active.c-sidebar-nav-dropdown-toggle {
    color: #fff;
    background: red !important;
}

.c-sidebar-brand {
    font-size: 20px;
    font-weight: 900;
}

</style>


